import React, { useState } from 'react';
import { Menu, Plus, Link, LogOut, Camera, Upload, HelpCircle, PlayCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import WelcomeVideo from './WelcomeVideo';

const HamburgerMenu = ({ onQuizClick, onAddCardClick, onBulkUploadClick, selectedGroup }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showWelcomeVideo, setShowWelcomeVideo] = useState(false);
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="relative">
      {showWelcomeVideo && (
        <WelcomeVideo onComplete={() => setShowWelcomeVideo(false)} />
      )}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-2 hover:bg-gray-100 rounded-full"
      >
        <Menu className="w-6 h-6" />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 z-50">
          <button
            onClick={() => {
              onQuizClick(selectedGroup);
              setIsOpen(false);
            }}
            className="w-full px-4 py-2 text-left hover:bg-gray-100 flex items-center gap-2"
          >
            <HelpCircle className="w-4 h-4" />
            Quiz Me
          </button>
          <button
            onClick={() => {
              onAddCardClick();
              setIsOpen(false);
            }}
            className="w-full px-4 py-2 text-left hover:bg-gray-100 flex items-center gap-2"
          >
            <Plus className="w-4 h-4" />
            Add Card
          </button>
          <button
            onClick={() => {
              onBulkUploadClick();
              setIsOpen(false);
            }}
            className="w-full px-4 py-2 text-left hover:bg-gray-100 flex items-center gap-2"
          >
            <Upload className="w-4 h-4" />
            Bulk Upload
          </button>
          <button
            onClick={() => {
              navigate('/photo-album');
              setIsOpen(false);
            }}
            className="w-full px-4 py-2 text-left hover:bg-gray-100 flex items-center gap-2"
          >
            <Camera className="w-4 h-4" />
            Photo Gallery
          </button>
          <button
            onClick={() => {
              navigate('/connect');
              setIsOpen(false);
            }}
            className="w-full px-4 py-2 text-left hover:bg-gray-100 flex items-center gap-2"
          >
            <Link className="w-4 h-4" />
            Connect
          </button>
          <button
            onClick={() => {
              navigate('/support');
              setIsOpen(false);
            }}
            className="w-full px-4 py-2 text-left hover:bg-gray-100 flex items-center gap-2"
          >
            <HelpCircle className="w-4 h-4" />
            Support
          </button>
          <button
            onClick={() => {
              setShowWelcomeVideo(true);
              setIsOpen(false);
            }}
            className="w-full px-4 py-2 text-left hover:bg-gray-100 flex items-center gap-2"
          >
            <PlayCircle className="w-4 h-4" />
            Welcome Video
          </button>
          <button
            onClick={() => {
              handleSignOut();
              setIsOpen(false);
            }}
            className="w-full px-4 py-2 text-left hover:bg-gray-100 flex items-center gap-2"
          >
            <LogOut className="w-4 h-4" />
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
};

export default HamburgerMenu; 